/**
 * API endpoint constants for the vetting application
 */

// Base URL for the API
// export const API_BASE_URL = 'https://upperco.app.n8n.cloud/webhook';
// export const API_BASE_URL = 'https://api.hirewise.at'; 
export const API_BASE_URL = 'https://hirewise-backend.upper.co/webhook';

// Questionnaire-related endpoints
export const QUESTIONNAIRE_ENDPOINTS = {  
  GET: `${API_BASE_URL}/get-questionnaire`,  
  START: `${API_BASE_URL}/start-questionnaire`,    
  SAVE: `${API_BASE_URL}/save-questionnaire`,  
  ABANDON: `${API_BASE_URL}/abandon-questionnaire`,
  
  // Audio/Video answer support
  SAVE_AUDIO_ANSWER: `${API_BASE_URL}/save-questionnaire-audio-answer`,
  SAVE_VIDEO_ANSWER: `${API_BASE_URL}/save-questionnaire-video-answer`,
};

// Evaluation-related endpoints // THIS IS ACTUALLY CHALLENGE, WE USED TO CALL IT EVALUATION EARLY ON
export const EVALUATION_ENDPOINTS = {
  GET: `${API_BASE_URL}/get-challenge`,  
  START: `${API_BASE_URL}/start-challenge`,
  SAVE: `${API_BASE_URL}/save-challenge`,
  ABANDON: `${API_BASE_URL}/abandon-challenge`,

  // used in quiz mode challenge
  SAVE_AUDIO_ANSWER: `${API_BASE_URL}/save-audio-answer`,
  SAVE_VIDEO_ANSWER: `${API_BASE_URL}/save-video-answer`,

  // used in interview mode challenge
  SUBMIT_QUESTION: `${API_BASE_URL}/submit-question`,
};

// Candidate-related endpoints
export const CANDIDATE_ENDPOINTS = {
  GET_DATA: `${API_BASE_URL}/get-eval-by-id`,
  SUBMIT_RESUME: `${API_BASE_URL}/submit-resume`,
  GET_EVALUATION_TEMPLATE: `${API_BASE_URL}/get-evaluation-template`,
  CREATE_CANDIDATE: `${API_BASE_URL}/create-candidate`,
};

// Reporting endpoints
export const REPORTING_ENDPOINTS = {
  REPORT_ITEM: `${API_BASE_URL}/report-evaluation-item`,
};


// Video endpoints
export const VIDEO_ENDPOINTS = {
  SAVE_VIDEO: `${API_BASE_URL}/savevideo`,
};

// Feedback endpoints
export const FEEDBACK_ENDPOINTS = {
  SAVE_FEEDBACK: `${API_BASE_URL}/save-feedback`,
};

// Other
export const OTHER_ENDPOINTS = {
  SIGN_URL: `${API_BASE_URL}/sign-url`,
};
